export const STRING_PARSE_INTRO = 'Review and Update your Profile';
export const STRING_PARSE_GET_STARTED = 'Get Started';

export const STRING_PARSE_WAIT = 'Please wait...';
export const STRING_PARSE_SUBMIT = 'Add to Profile';
export const STRING_PARSE_SKIP = 'Skip this entry';
